module.exports = __webpack_public_path__ + "static/button-sound-82f46800980ed3e63a623d8d62db0ae3.png";